<template>
  <div>
    <v-row align="center">
      <v-col>
        <company-form
          :value="value"
          :loading="loading"
          @input="onInput"
        />
      </v-col>
      <v-col>
        <div class="text-center">
          <template v-if="hasTrainedPlayer">
            <h2 v-text="$t('company.title.trainedPlayerChart')" />
            <trained-player-chart :value="company.trainedPlayerQtyByMonth" />
          </template>
          <h3 v-else class="mx-10" v-text="$t('company.emptyTrainedPlayerChart')" />
        </div>
      </v-col>
    </v-row>

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _pick from 'lodash/pick'

import Repositories from 'src/repositories'

import CompanyForm from '../components/CompanyForm'
import TrainedPlayerChart from '../components/TrainedPlayerChart'

export default {
  name: 'CompanyGeneralContainer',
  components: {
    CompanyForm,
    TrainedPlayerChart,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    value () {
      return {
        ...this.company,
        companyContact: this.company?.companyContact?.id ?? null,
        masterContactList: this.company.masterContactList.map(user => user.id),
      }
    },
    hasTrainedPlayer () {
      return this.company.trainedPlayerQtyByMonth.some(item => item.qty)
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async onInput (company) {
      this.loading = true
      try {
        const newCompany = await Repositories.company.patch(_pick(company, [
          'id',
          'companyLogin',
          'displayName',
          'companyContact',
          'masterContactList',
          'logo',
        ]))
        this.$emit('update:company', newCompany)
        this.showSuccessNotification(this.$t('company.companyUpdated'))
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
